import React, { useEffect } from 'react';
import { Col, Row, Card, Form, ButtonGroup, Button } from '@themesberg/react-bootstrap';

import 'react-quill/dist/quill.snow.css';
import { simpleDecrypt } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { storeTypes } from '../types';
import { config } from 'config';
import { useParams } from 'react-router-dom';
import { studentDataSingleSaga } from '../reduxToolkit/actions';
import { StudentEventTables } from '../components/Student/StudentEventTables';

const StudentView = () => {
    const dispatch = useDispatch();
    const { studentId } = useParams<{ studentId: string }>();
    const { studentDataSingleState } = useSelector((state: storeTypes.IStore) => state);
    const { data } = studentDataSingleState;

    //Watch Params
    useEffect(() => {
        if (studentId) {
            const student_Id = simpleDecrypt(studentId);
            const dispatchPayload = {
                studentId: student_Id,
            };
            dispatch(studentDataSingleSaga(dispatchPayload));
        }
    }, [studentId]);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <h4>Student Detail</h4>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                        <a href="/students">
                            <Button variant="outline-primary" size="sm">
                                Back
                            </Button>
                        </a>
                    </ButtonGroup>
                </div>
            </div>

            <Row>
                <Col xs={12} xl={8}>
                    <Card border="light" className="bg-white shadow-sm mb-4">
                        <Card.Body>
                            {/* Title and description */}
                            <Row>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Name</b>
                                        </Form.Label>
                                        <Card.Text>{data?.name}</Card.Text>
                                    </Form.Group>
                                </Col>

                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Email</b>
                                        </Form.Label>

                                        <Card.Text>{data?.email}</Card.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Mobile Number</b>
                                        </Form.Label>
                                        <Card.Text>{data?.mobileNumber}</Card.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Start and end date */}
                            <Row className="align-items-center">
                                <Col md={6} className="mb-3">
                                    <Form.Group id="birthday">
                                        <Form.Label>
                                            <b>College Name</b>
                                        </Form.Label>
                                        <Card.Text>{data?.collegeName}</Card.Text>
                                    </Form.Group>
                                </Col>

                                <Col md={6} className="mb-3">
                                    <Form.Group id="birthday">
                                        <Form.Label>
                                            <b>Department</b>
                                        </Form.Label>
                                        <Card.Text>{data?.department}</Card.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Fees and Offer */}
                            <Row>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Year of study</b>
                                        </Form.Label>
                                        <Card.Text>{data?.whichYear}</Card.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="gender">
                                        <Form.Label>
                                            <b>Nationality</b>
                                        </Form.Label>
                                        <Card.Text>{data?.nationality}</Card.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>State</b>
                                        </Form.Label>
                                        <Card.Text>{data?.state}</Card.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>City</b>
                                        </Form.Label>
                                        <Card.Text>{data?.city}</Card.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs={12} xl={4}>
                    <Row>
                        <Col xs={12}>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>
                                    <b>Image</b>
                                </Form.Label>
                            </Form.Group>

                            {data?.file_path ? (
                                <Card border="light" className="text-center p-0 mb-4">
                                    <div
                                        style={{ backgroundImage: `url(${config.apiBaseURL}/${data?.file_path})` }}
                                        className="profile-cover rounded-top"
                                    />
                                </Card>
                            ) : null}
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <div className="d-block mb-4 mb-md-0">
                    <h4>Event Details</h4>
                </div>
                <Col xs={12} xl={12}>
                    <StudentEventTables />
                </Col>
            </Row>
        </>
    );
};

export default StudentView;
